import { Alchemy, Network } from "alchemy-sdk";
import { IS_DEV } from "src/constants";

const config = {
    apiKey: IS_DEV ? "OXrvLo6eKYcTAu5PaBMoBX4m13iZ-E34" : "HGWgCONolXMB2op5UjPH1YreDCwmSbvx",
    network: IS_DEV ? Network.ETH_SEPOLIA : Network.ETH_MAINNET,
};

export const alchemy = new Alchemy(config);
